export const shouldOpenDrawer = (lg: number) => (window.innerWidth > lg ? true : false);
